var a;(function(t){t.category="category",t.city="city",t.region="region",t.advertDetail="advertDetail",t.categoryInCity="categoryInCity",t.area="area",t.reviewList="reviewList",t.page="page"})(a||(a={}));export{a as Type};
